module.exports = __webpack_public_path__ + "static/media/purchase_month.e4c134ba.png";